import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { withRouter } from 'react-router';
import LoadingSpinner from "../dev/LoadingSpinner";
import CrossIcon from "../icon/Cross";
import CheckIcon2 from '../icon/CheckIcon2'


class PaymentGuide extends Component {
    state = {
        targetPlan: "",
        isDescriptionButtom: true,
    };
    componentDidMount() {
        const { paymentGuideMinPlan } = this.props.payment
        this.setState({ targetPlan: paymentGuideMinPlan, minPlan: paymentGuideMinPlan})
    }
    componentWillUnmount() {
        this.props.dispatch({
            type: "togglePaymentField",
            isPaymentGuideActive: false,
            paymentGuideMinPlan: "",
        });
    }
    getPaymentApiCase = () => { //辨別 call 哪支 api 
        const { user: {plan}, user: {canITrial} } = this.props
        if (canITrial && plan === 'Free') return 'trial' // 免費試用
        if (plan === '' || plan === 'Free') return 'payment' // 購買
        else return 'upgrade' // 升級（ 若在試用中升級方案也是用升級 api ）
    }
    getPaymentTextCase = () => {
        const {
            user: { plan, isTrialing, canITrial},
        } = this.props;
        if(isTrialing) { //是否試用中
            return 'trialing' //試用中
        }
        if(!canITrial) { //不可試用
            return plan === 'Free' 
                    ? 'trialedOrCanceled' //已試用過，未購買過
                    : 'dad' //已購買過
        }
        else return 'canTrial' //未試用，未購買，非試用中
    }
    renderPlanButtons = () => {
        const { targetPlan, minPlan } = this.state
        // const { plan } = this.props.user 
        const selector = ['Free', 'Creator', 'Brand', 'Agency']
        const buttons = selector.slice(selector.indexOf(minPlan))
        return buttons.map((plan, index) => {
            return (
                <PlanButton
                    onClick={() => this.setState({ targetPlan: plan})}
                    isTarget={targetPlan === "" ? index === 0 : targetPlan === plan}
                    left={buttons.length > 1 && index === 0}
                    center={buttons.length > 2 && index === 1}
                    only={buttons.length === 1 && index === 0}
                >
                    {plan}
                </PlanButton>)
        })
    }
    getPrice = () => {
        const { targetPlan } = this.state
        if( targetPlan === "Creator") return '$2.9'
        if( targetPlan === "Brand") return '$99'
        if( targetPlan === "Agency") return '$199'
    }
    renderPlanDescription = () => {
        const {messages} = this.props
        const {targetPlan} = this.state
        const selector = {Creator: 1, Brand: 2, Agency: 3}
        const descriptions = [
            { key: 'pricing_rank_01', descriptionMinPlan: 'Creator'}, //完整排行榜
            { key: 'pricing_rank_02', descriptionMinPlan: 'Creator'},
            { key: 'pricing_rank_03', descriptionMinPlan: 'Creator'},
            { key: 'pricing_info_01', descriptionMinPlan: 'Brand'}, //網紅檢索
            { key: 'pricing_info_02', descriptionMinPlan: 'Brand'},
            { key: 'pricing_info_03', descriptionMinPlan: 'Brand'},
            { key: 'pricing_data_01', descriptionMinPlan: 'Brand'}, //數據分析
            { key: 'pricing_data_02', descriptionMinPlan: 'Brand'},
            { key: 'pricing_data_03', descriptionMinPlan: 'Brand'},
            { key: 'pricing_propoasal_01', descriptionMinPlan: 'Agency'}, //提案清單管理
            { key: 'pricing_propoasal_02', descriptionMinPlan: 'Agency'},
            { key: 'pricing_propoasal_03', descriptionMinPlan: 'Agency'},
            { key: 'pricing_propoasal_04', descriptionMinPlan: 'Agency'},
        ]
        // const description = allDescriptions.slice(0, targetPlan === 'Creator' ? 3 : targetPlan === 'Brand' ? 9 : allDescriptions.length))
        return descriptions.map(({ key, descriptionMinPlan }) => <Description isTarget={ selector[descriptionMinPlan] <= selector[targetPlan]} highlight={key.substring(key.length - 1) === '1'}>
            <CheckIcon2 size="12px" color={selector[descriptionMinPlan] <= selector[targetPlan] ? "#de0606" : "#dedede"}/>
            <span>{messages[key]}</span>
        </Description>)
    }
    render() {
        const {renderPlanButtons, getPrice, renderPlanDescription, handleDescriptionScroll} = this
        const {targetPlan} = this.state;
        const {
            messages,
            user: { plan, isTrialing, canITrial},
            payment: { isPaymentActive, isPaymentGuideActive }
        } = this.props;
        const isUpgrade = !isTrialing && !canITrial
        return (
            <Wrap isActive={isPaymentGuideActive && !isPaymentActive}>
                <Nav>
                    {messages.user_givememoneyfirst}
                    <CancelButton
                        onClick={() =>
                            this.props.dispatch({
                                type: "togglePaymentField",
                                isPaymentGuideActive: false
                            })
                        }
                    >
                        <CrossIcon color="#fff" size="12px"/>
                    </CancelButton>
                </Nav>
                {plan === "" ? <LoadingSpinner/> :
                    <Containter>
                        <Content content="center" items="center" padding="10px">
                            {messages.choose_a_plan}
                        </Content>
                        <Content content="center">
                            {renderPlanButtons()}
                        </Content>
                        <Content content="center" margin="10px 0">
                            <Price highlight>{getPrice()} USD </Price>
                            <Price>/ month</Price>
                        </Content>
                        <Content id="descriptionField" onScroll={handleDescriptionScroll} rwd direction="column" items="center">
                            <Content direction="column" width="auto" border='2px 0 0 0 '>
                                {renderPlanDescription()}
                            </Content>
                            <Content content="center" padding="15px 0 30px 0">
                                <PaymentButton
                                    id={`ga_${targetPlan}_${isUpgrade ? "payment" : "trial"}_guide`}
                                    onClick={() => {
                                        targetPlan === "Agency" ? 
                                            this.props.dispatch({ type: "togglePaymentField", isPaymentGuideActive: false}) &&
                                            this.props.history.push('/AgencyPayment/Payment') :
                                            this.props.dispatch({
                                                type: "togglePaymentField",
                                                isPaymentActive: true,
                                                paymentApiCase: this.getPaymentApiCase(),
                                                paymentTextCase: this.getPaymentTextCase(),
                                                buyPlan: targetPlan,
                                                buyAmount: getPrice(),
                                        })
                                    }}
                                >{isUpgrade ? messages.user_upgrade : messages.free_trial}</PaymentButton>
                            </Content>
                        </Content>
                    </Containter>} 
            </Wrap>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.User,
        payment: state.Payment,
        messages: state.Messages
    };
};
PaymentGuide.defaultProps = {
    user: {
        auth: "notSignIn"
    }
};
export default withRouter(connect(mapStateToProps)(PaymentGuide));
const Wrap = styled.div`
    position: fixed;
    visibility: ${props => (props.isActive ? "visible" : "hidden")};
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 350px;
    top: 0;
    left: 50%;
    transform: translate(-50%, 82px);
    z-index: 10002;
    font-size: 16px;
    font-weight: 500;
    color: #787878;
    background-color: #fafafa;
    border-radius: 5px;
    @media (max-width: 665px) {
        top: 0;
        left: 0;
        transform: translate(0, 0);
        min-width: 100%;
    }
`;
const Nav = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 10px 0;
    background-color: #e94242;
    border-radius: 5px 5px 0 0;
    color: #fff;
    font-weight: 500;
    font-size: 20px;
`;
const CancelButton = styled.div`
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    right: 0;
    top: 0;
    border-radius: 100%;
    cursor: pointer;
`;
const Containter = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: 0 50px;
    font-size: 14px;
    @media (max-width: 665px) {
        padding: 0 20px 0 20px;
    }
`;
const Content = styled.div`
    display: flex;
    flex-direction: ${({ direction }) => direction};
    justify-content: ${({ content }) => (content ? content : "")};
    align-items: ${({ items }) => (items ? items : "")};
    width: ${({ width }) => (width ? width : "100%")};
    padding: ${({ padding }) => padding};
    margin: ${({ margin }) => margin};
    border: 0 solid #dedede;
    border-width: ${({border}) => border};
    @media (max-width: 665px) {
        ${({rwd}) => rwd ? 'max-height: calc(100vh - 245px); overflow: scroll;': ''};
    }
`;
const PlanButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 35%;
    padding: 5px 0;
    background-color: ${({ isTarget }) => isTarget ? '#e94242' : ''};
    color: ${({ isTarget }) => isTarget ? '#fff' : ''};
    cursor: pointer;
    border: ${({ isTarget }) => isTarget ? 'solid #e94242' : 'solid #dedede'};;
    border-width: ${({ center }) => { 
        if(center) return '2px 0'
        else return '2px'
    }};
    border-radius: ${({ left, right, center, only }) => { 
        if(left) return '10px 0 0 10px'
        if(center) return '0'
        if(only) return '10px'
        else return '0 10px 10px 0'
    }};
    transition: all .2s ease-in-out;
`;
const Price = styled.span`
    color: ${({ highlight }) => highlight ? '#de0606' : '#787878'};
    font-size: 20px;
    white-space: pre;
`
const Description = styled.div`
    display: flex;
    align-items: flex-start;
    font-weight: ${({ highlight }) => highlight ? '500' : '300'};
    margin-top: ${({ highlight }) => highlight ? '15px' : ''};
    color: ${({ isTarget }) => isTarget ? '#787878' : '#dedede'};
    transition: color .2s ease-in-out;
    svg {
        min-width: 12px;
        min-height: 1rem;
        transition: all .2s ease-in-out;
    }
    span {
        margin-left: 8px;
        white-space: nowrap;
        @media (max-width: 665px) {
            white-space: initial;
        }
    }
`
const PaymentButton = styled.div`
    display: flex;
    align-items:center;
    justify-content: center;
    padding: 3px 30px;
    background-color: #e94242;
    border-radius: 15px;
    font-size: 20px;
    color: #fff;
    font-weight: 500;
    cursor: pointer;
`


// WEBPACK FOOTER //
// ./src/Payment/PaymentGuide.js